import { GeneratedAnswer } from '@repo/backend-api-spec';
import { LpRIDWoord, LpRidWords } from '../../../../typings/schema';
import { doesIndexInclude } from '../../../mechanics/rid-reading-matrix-timer/rid-reading-matrix-timer.utils';

/**
 * The words of a list that were read: every word, or with a `lastRead` (the timer mode's selection) only the words up
 * to it. Each matrix holds word groups as its columns.
 */
export function readWords(matrices: LpRidWords[][], lastRead?: [matrix: number, col: number, row: number]): LpRIDWoord[] {
  return matrices.flatMap((groups, matrix) =>
    groups.flatMap((group, col) => group.words.filter((_, row) => !lastRead || doesIndexInclude([matrix, col, row], lastRead))),
  );
}

/** How many words were read per minute, if any time passed. */
export function wordsPerMinute(wordCount: number, durationMs: number): number | undefined {
  return durationMs > 0 ? (wordCount * 60_000) / durationMs : undefined;
}

/**
 * The answers for the words read: the star rating (0-4) as a percentage, so 'alles goed' is 100, and the reading speed
 * of the whole list, as far as they're known.
 */
export function readingAnswers(words: LpRIDWoord[], rating: number | undefined, speed: number | undefined): GeneratedAnswer[] {
  if (rating === undefined && speed === undefined) return [];

  return words.map((word) => ({
    dataInstanceUid: word.uid,
    ...(rating !== undefined && { accuracy: rating * 25 }),
    ...(speed !== undefined && { wordsPerMinute: speed }),
  }));
}

/**
 * The answers for reading the words of a list, up to `lastRead` if given, with the star rating and the speed over
 * `durationMs` as far as they're known.
 */
export function leeslijstAnswers(
  matrices: LpRidWords[][],
  rating: number | undefined,
  durationMs: number | undefined,
  lastRead?: [matrix: number, col: number, row: number],
): GeneratedAnswer[] {
  const words = readWords(matrices, lastRead);
  const speed = durationMs === undefined ? undefined : wordsPerMinute(words.length, durationMs);
  return readingAnswers(words, rating, speed);
}
